import { useTranslation } from 'react-i18next'
import { LanguageSwitcher } from '@/components/common/LanguageSwitcher'
import '@/styles/landing.css'
import './onboardingHeader.css'

interface OnboardingHeaderProps {
  /** Уйти в кабинет: до конца теста это отказ от мастера, после — обычный переход. */
  onLeave: () => void
  /** Подпись кнопки ухода: «Пропустить» либо «В кабинет». */
  leaveLabel: string
  /** Что именно случится при уходе: отказ окончательный, и сказать об этом надо. */
  leaveHint?: string
  leaveDisabled?: boolean
  onLogout: () => void
}

/**
 * Шапка полноэкранного мастера онбординга.
 *
 * Стили те же, что у шапки лендинга: ученик, пришедший с сайта, видит ту же
 * полосу с логотипом, а не чужой экран. Разметка своя, потому что действия
 * здесь другие — разделы лендинга увели бы человека из мастера посреди теста.
 *
 * Кнопки лежат в собственном контейнере, а не в `.nav-links`: на узком экране
 * тот прячется под гамбургер, и выход из мастера пропал бы вместе с ним.
 */
export function OnboardingHeader({
  onLeave,
  leaveLabel,
  leaveHint,
  leaveDisabled = false,
  onLogout,
}: OnboardingHeaderProps) {
  const { t } = useTranslation()

  return (
    <header className="header onboarding-header">
      <div className="container">
        <nav className="nav">
          {/* Логотип не ссылка: с лендинга ученик уже пришёл, и уводить его
              обратно на середине теста незачем */}
          <span className="logo">
            <img
              src="/icon/android-chrome-192x192.png"
              alt="EASYA"
              onError={(e) => {
                const target = e.target as HTMLImageElement
                target.src = '/icon/apple-touch-icon.png'
                target.onerror = () => {
                  target.src = '/icon/favicon-32x32.png'
                }
              }}
            />
            EASYA
          </span>

          <div className="onboarding-header-actions">
            <div className="header-language-switcher">
              <LanguageSwitcher />
            </div>

            <button
              type="button"
              className="btn-secondary"
              title={leaveHint}
              disabled={leaveDisabled}
              onClick={onLeave}
            >
              {leaveLabel}
            </button>

            {/* Выход обязателен: бокового меню в мастере нет, и без него
                человек, у которого экран не грузится, заперт в нём */}
            <button type="button" className="nav-link onboarding-header-logout" onClick={onLogout}>
              {t('auth.logout')}
            </button>
          </div>
        </nav>
      </div>
    </header>
  )
}
